export default "__VITE_ASSET__DYTT8sn9__"